import { ReactNode, createContext, useContext, useState } from "react";

type TopbarContextType = {
    isBrandSelectorOpen: boolean;
    setIsBrandSelectorOpen: (open: boolean) => void;
    isPhoneNumberSelectorOpen: boolean;
    setIsPhoneNumberSelectorOpen: (open: boolean) => void;
};

const TopbarContext = createContext<TopbarContextType | undefined>(undefined);

export const TopbarProvider = ({ children }: { children: ReactNode }) => {
    const [isPhoneNumberSelectorOpen, setIsPhoneNumberSelectorOpen] = useState(false);
    const [isBrandSelectorOpen, setIsBrandSelectorOpen] = useState(false);

    return (
        <TopbarContext.Provider
            value={{
                isBrandSelectorOpen,
                setIsBrandSelectorOpen,
                isPhoneNumberSelectorOpen,
                setIsPhoneNumberSelectorOpen,
            }}
        >
            {children}
        </TopbarContext.Provider>
    );
};

export const useTopbar = () => {
    const context = useContext(TopbarContext);
    if (context === undefined) {
        throw new Error("useTopbar must be used within a TopbarProvider");
    }
    return context;
};
